import React from 'react';
import { ContactsForm } from './Form';

export default function ContactsCreate(props) {
    return <ContactsForm {...props} />;
}
